import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { ImageOverlay } from '@tcc/treadstone';
import { getCurrentEvent } from '../../../selectors/eventSelectors';
import { inverseCoordinates as inverse } from '../../../utils/geo';

export function CropWaterMap({ bounds, image }) {
  return <ImageOverlay bounds={bounds} url={image} />;
}

CropWaterMap.propTypes = {
  bounds: PropTypes.object,
  image: PropTypes.string,
};

function mapStateToProps(state, props) {
  const currentEvent = getCurrentEvent(state, props);
  const { fullSize: image } = currentEvent;
  return {
    image: image.uri,
    bounds: inverse([
      image.bbox.northeast.coordinates,
      image.bbox.southwest.coordinates,
    ]),
  };
}

export default connect(mapStateToProps)(CropWaterMap);
